const apiUrl = process.env.REACT_APP_API_URL;
export const DeleteIngredient = async ( id_usu_log: string, id_ingredient: number , page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8072/ingredients/${id_usu_log}?id=${id_ingredient}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
